
import React, { useEffect, useState } from "react";
import { Form, Col, Modal } from "react-bootstrap";
import PermissionOptions from "./PermissionOptions";
import {formToDeepObject} from "../../../../../util/Helpers";

const EditAdmin = ({show, onHide, editAdmin, admin}) => {

  const [validated, setValidated] = useState(false);
  const [adminType, setAdminType] = useState(null);

  const handleSubmit = e =>  {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;

    if (form.checkValidity() === true) {
      const formData = new FormData(form);
      onHide();
      editAdmin({id: admin.id, status: admin.status, ...formToDeepObject(Object.fromEntries(formData.entries()), "permissions")});
    }
    setValidated(true);
  }

  // Restore adminType state on Hide
  useEffect(() => {
    return _ => setAdminType(null);
  }, [show])
    
  return (
    <Modal
        show={show}
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        keyboard={false}
        onExited={_ => setValidated(false)}
      >
      <Form
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
      >
        <Modal.Header >
          <Modal.Title id="contained-modal-title-vcenter">
            Update Admin
          </Modal.Title>
          <button type="button" className="close" onClick={onHide}>
              <span aria-hidden="true" className="d-block">×</span>
              <span className="sr-only">Close</span>
           </button>
        </Modal.Header>
        <Modal.Body style={{maxHeight: "calc(100vh - 300px)", overflow: "auto"}}>
            <Form.Row>
              <Form.Group as={Col} md="6" controlId="firstName">
                <Form.Label >First name</Form.Label>
                <Form.Control
                  required
                  type="text"
                  name="firstName"
                  defaultValue={admin?.firstName}
                  autoComplete="off"
                />
                <Form.Control.Feedback  type="invalid">Please provide admin First Name</Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="lastName">
                <Form.Label >Last name</Form.Label>
                <Form.Control
                  required
                  type="text"
                  name="lastName"
                  defaultValue={admin?.lastName}
                  autoComplete="off"
                />
                <Form.Control.Feedback type="invalid">Please provide admin Last Name</Form.Control.Feedback>
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} md="6" controlId="adminLevel">
                <Form.Label >Admin Type</Form.Label>
                <Form.Control
                        required
                        as="select"
                        className="mr-sm-2"
                        custom
                        name="adminLevel"
                        defaultValue={admin?.adminLevel}
                        autoComplete="off"
                        onChange={e => setAdminType(e.currentTarget.value)}
                    >
                        <option value="1">Admin</option>
                        <option value="2">Super Admin</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                    Select the Admin Type
                    </Form.Control.Feedback>


               </Form.Group>
              <Form.Group as={Col} md="6" controlId="status">
                <Form.Label >Status</Form.Label>
                <Form.Control
                        required
                        as="select"
                        className="mr-sm-2"
                        custom
                        name="status"
                        defaultValue={admin?.status}
                        disabled={admin?.status === "PENDING"}
                    >   
                        {admin?.status === "PENDING" ? <option value="PENDING">PENDING</option> : "" }
                        <option value="ACTIVE">ACTIVE</option>
                        <option value="DISABLED">DISABLED</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      Select the Admin Status
                    </Form.Control.Feedback>


               </Form.Group>
            </Form.Row>
            {(adminType === "1" || ( adminType === null && admin?.adminLevel === 1)) && <PermissionOptions permissions={admin?.permissions} />}
        </Modal.Body>
        <Modal.Footer>
            <button
                type="button"
                onClick={onHide}
                className="btn btn-light btn-elevate px-4"
            >
                Cancel
            </button>
            <> </>
            <button
                type="submit"
                className="btn btn-primary btn-elevate px-4 ml-4"
            >
                Update
            </button>
        </Modal.Footer>
          </Form>
      </Modal>

        );
}

export default EditAdmin;